<div id="page-wrapper" class="page-wrapper toggled-sidebar">
    <app-header *ngIf="auth?.user && auth?.selectedCompany"></app-header>
    <app-sidebar *ngIf="auth?.user && auth?.selectedCompany"></app-sidebar>
    <!-- <app-comment-chart></app-comment-chart> -->
    <main id="main"> 
        <router-outlet *ngIf="auth?.user && auth?.selectedCompany"></router-outlet>
    </main>
</div>
<app-net-info></app-net-info>